import './MobileBannerPreview.css';

export const BANNER_PREVIEW_WIDTH = 350;
export const BANNER_PREVIEW_HEIGHT = 126;
export const BANNER_ASPECT_RATIO = BANNER_PREVIEW_WIDTH / BANNER_PREVIEW_HEIGHT;

const BANNER_PREVIEW_CONFIG = {
  height: BANNER_PREVIEW_HEIGHT,
  referenceWidth: BANNER_PREVIEW_WIDTH,
  borderRadius: 16,
  gradientStart: 'rgba(0, 0, 0, 0.6)',
  gradientEnd: 'transparent',
};

const MobileBannerPreview = ({
  imageUrl,
  title = '',
  placement = '',
  onImageError,
  className = '',
  onUploadRequest,
  onRemove,
  isUploading = false,
  uploadIcon,
}) => {
  const isInteractive = Boolean(onUploadRequest);
  const isEmptyInteractive = isInteractive && !imageUrl;
  const aspectRatio = `${BANNER_PREVIEW_CONFIG.referenceWidth} / ${BANNER_PREVIEW_CONFIG.height}`;

  return (
    <div className={`mobile-banner-preview-wrapper ${className}`.trim()}>
      <div
        className={`mobile-banner-preview ${
          isEmptyInteractive ? 'mobile-banner-preview--interactive-empty' : ''
        }`.trim()}
        style={{
          aspectRatio,
          borderRadius: `${BANNER_PREVIEW_CONFIG.borderRadius}px`,
        }}
      >
        {imageUrl ? (
          <img
            key={imageUrl}
            src={imageUrl}
            alt={title || 'Banner preview'}
            className="mobile-banner-preview-image"
            onError={onImageError}
          />
        ) : isInteractive ? (
          <button
            type="button"
            className="mobile-banner-preview-empty-state"
            onClick={onUploadRequest}
            disabled={isUploading}
          >
            {uploadIcon ? (
              <img src={uploadIcon} alt="" className="mobile-banner-preview-empty-icon" />
            ) : null}
            <span>{isUploading ? 'Uploading...' : 'Click to upload image'}</span>
          </button>
        ) : (
          <div className="mobile-banner-preview-placeholder" />
        )}
        {imageUrl ? (
          <div
            className="mobile-banner-preview-gradient"
            style={{
              background: `linear-gradient(to right, ${BANNER_PREVIEW_CONFIG.gradientStart}, ${BANNER_PREVIEW_CONFIG.gradientEnd})`,
            }}
          />
        ) : null}
        {imageUrl ? (
          <div className="mobile-banner-preview-text">
            {title?.trim() ? <div className="mobile-banner-preview-title">{title}</div> : null}
            {placement?.trim() ? (
              <div className="mobile-banner-preview-placement">{placement}</div>
            ) : null}
          </div>
        ) : null}
        {imageUrl && isInteractive ? (
          <div className="mobile-banner-preview-actions">
            <button
              type="button"
              className="mobile-banner-preview-action-btn"
              onClick={onUploadRequest}
              disabled={isUploading}
            >
              {isUploading ? 'Uploading...' : 'Change'}
            </button>
            {onRemove ? (
              <button
                type="button"
                className="mobile-banner-preview-action-btn mobile-banner-preview-action-btn--muted"
                onClick={onRemove}
                disabled={isUploading}
              >
                Remove
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MobileBannerPreview;
